<template>
  <div>
    <vue-headful title="ZZP documenten" />
    <Header page_title="ZZP documenten" />
    <div class="heading border-bottom">
      <div class="max-600">
        <div class="d-flex align-items-center px-4 mx-2">
          <div class="flex-grow-1">
            <h2 class="d-inline-block position-relative mb-0">
              ZZP Documenten
            </h2>
          </div>
          <div class="icon position-relative">
            <svg
              version="1.1"
              viewBox="0 0 73 73"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="none" fill-rule="evenodd">
                <g fill="#DCDBDB" fill-rule="nonzero">
                  <path
                    d="m36.5 0c-20.11 0-36.5 16.39-36.5 36.5s16.39 36.5 36.5 36.5 36.5-16.39 36.5-36.5-16.39-36.5-36.5-36.5zm0 66.49c-16.506 0-29.99-13.484-29.99-29.99s13.484-29.99 29.99-29.99 29.99 13.484 29.99 29.99-13.484 29.99-29.99 29.99z"
                  />
                  <g transform="translate(24 19)">
                    <path
                      d="m21.747 0h-18.495c-1.7776 0-3.2526 1.5081-3.2526 3.3255v29.349c0 1.8174 1.475 3.3255 3.2526 3.3255h18.495c1.7776 0 3.2526-1.5081 3.2526-3.3255v-29.349c0-1.8174-1.475-3.3255-3.2526-3.3255zm-9.2663 5.6842c1.3994 0 2.4962 1.16 2.4962 2.5521s-1.1346 2.5521-2.4962 2.5521c-1.3616 0-2.4962-1.16-2.4962-2.5521s1.1346-2.5521 2.4962-2.5521zm-3.2905 8.855c0-0.88937 1.475-2.5908 3.2905-2.5908 1.8154 0 3.2905 1.7014 3.2905 2.5908v1.16c0 2.4361-0.34039 2.7068-1.7776 2.7068h-3.0257c-1.475 0-1.7776-0.27068-1.7776-2.7068v-1.16zm10.703 15.235h-14.788c-0.5295 0-0.90772-0.38668-0.90772-0.92803s0.41604-0.92803 0.90772-0.92803h14.826c0.49168 0 0.90772 0.42535 0.90772 0.92803s-0.45386 0.92803-0.94554 0.92803zm0-4.7175h-14.788c-0.49168 0-0.90772-0.42535-0.90772-0.92803 0-0.50269 0.37821-0.92803 0.90772-0.92803h14.826c0.49168 0 0.90772 0.42535 0.90772 0.92803 0 0.50269-0.45386 0.92803-0.94554 0.92803z"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <section class="block max-600 px-4 mx-2 pt-4">
      <NotificationContainer />
    </section>
    <section class="block border-bottom">
      <div class="max-600">
        <div class="px-4 mx-2 py-4">
          <h3 class="clearfix mb-0">
            <span class="float-left">KvK uittreksel:</span>
          </h3>
          <small>Upload hier je KvK uittreksel. Let op: deze mag maximaal drie maanden oud zijn.</small>
          <div v-for="file in displayKvkFiles" :key="file.id">
            <hr>
            <div v-if="file.valid_until != null">
              <small>Geldig tot en met: {{ dateFlip(file.valid_until) }}</small>
            </div>
            <div class="upload-info-container">
              <div class="upload-info">{{ file.original_filename }}</div>
              <span v-if="file.status == 'pending'" class="upload-info">status: <span class="upload-status-new">in afwachting</span></span>
              <span v-else-if="file.status == 'approved'" class="upload-info">status: <span class="upload-status-approved">goedgekeurd</span></span>
              <span v-else-if="file.status == 'rejected'" class="upload-info">status: <span class="upload-status-rejected">afgekeurd</span></span>
              <span v-else-if="file.status == 'expired'" class="upload-info">status: <span class="upload-status-rejected">verlopen</span></span>
              <span v-else-if="file.status == 'new'" class="upload-info">status: <span class="upload-status-new">nieuw</span></span>
            </div>
          </div>
          <div :hidden="this.hasUploadedKvkFile">
            <label class="btn btn-gray btn-block">
              <span>Klik hier om een KvK uittreksel te uploaden</span>
              <input
                :id="'kvk-upload'"
                type="file"
                :ref="'new_kvk_image'"
                @change="onFileUpload('kvk')"
                accept="image/x-png, image/jpeg"
                class="btn btn-gray btn-block"
                style="display: none"
              />
            </label>
          </div>
        </div>
      </div>
    </section>
    <section class="block border-bottom">
      <div class="max-600">
        <div class="px-4 mx-2 py-4">
          <h3 class="clearfix mb-0">
            <span class="float-left">Bewijs aansprakelijkheidsverzekering:</span>
          </h3>
          <small>Upload hier je bewijs aansprakelijkheidsverzekering</small>
          <div v-for="file in displayInsuranceFiles" :key="file.id">
            <hr>
            <div v-if="file.valid_until != null">
              <small>Geldig tot en met: {{ dateFlip(file.valid_until) }}</small>
            </div>
            <div class="upload-info-container">
              <div class="upload-info">{{ file.original_filename }}</div>
              <span v-if="file.status == 'pending'" class="upload-info">status: <span class="upload-status-new">in afwachting</span></span>
              <span v-else-if="file.status == 'approved'" class="upload-info">status: <span class="upload-status-approved">goedgekeurd</span></span>
              <span v-else-if="file.status == 'rejected'" class="upload-info">status: <span class="upload-status-rejected">afgekeurd</span></span>
              <span v-else-if="file.status == 'expired'" class="upload-info">status: <span class="upload-status-rejected">verlopen</span></span>
              <span v-else-if="file.status == 'new'" class="upload-info">status: <span class="upload-status-new">nieuw</span></span>
            </div>
          </div>
          <div :hidden="this.hasUploadedInsuranceFile">
            <label class="btn btn-gray btn-block">
              <span>Klik hier om een bewijs aansprakelijkheidsverzekering te uploaden</span>
              <input
                :id="'liability-insurance-upload'"
                type="file"
                :ref="'new_liability-insurance_image'"
                @change="onFileUpload('liability-insurance')"
                accept="image/x-png, image/jpeg"
                class="btn btn-gray btn-block"
                style="display: none"
              />
            </label>
          </div>
        </div>
      </div>
    </section>
    <div class="px-4 mx-2 pt-4">
      <small v-if="this.hasUploadedInsuranceFile || this.hasUploadedKvkFile">Oude documenten worden automatisch verwijderd wanneer je een nieuwe versie van een document uploadt. </small>
      <small v-if="this.hasUploadedKvkFile">Je kan tijdelijk niet reageren op vacatures tot we je nieuwe document(en) hebben goedgekeurd. We doen dit zo snel mogelijk!</small>
      <button
        type="button"
        class="btn btn-warning btn-block mt-2"
        @click="onSave"
        :disabled="!hasUploadedFile"
      >
        Opslaan
      </button>
    </div>
    <div class="px-4 mx-2 py-4">
      <router-link
        :to="{ name: 'applicant-dashboard' }"
        title="Naar mijn Dashboard"
        class="btn btn-warning btn-block"
        v-ripple="'rgba(255, 255, 255, 0.35)'"
      >
        <strong>Naar mijn Dashboard</strong>
      </router-link>
    </div>
  </div>
</template>

<script>
import VueSlideBar from "vue-slide-bar";
export default {
  components: {
    VueSlideBar
  },
  data: function() {
    return {
      user: "",
      displayKvkFiles: [],
      displayInsuranceFiles: [],
      newFiles: [],
      uploadedFiles: [],
      saveOnUpdate: false,
      hasUploadedFile: false,
      hasUploadedKvkFile: false,
      hasUploadedInsuranceFile: false,
      allowedNewUploads: 3
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.user = JSON.parse(localStorage.getItem("user"));
      return new Promise((resolve, reject) => {
        var url = this.$apiURI + "/applicant/uploads/zzpdocs/get/" + this.user.id;
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .get(url, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(resp => {
            if (resp.data) {
              if (resp.data.length > 0) {
                for (var i = 0; i < resp.data.length; i++) {
                  var newEntry = new Array();
                  newEntry.id = resp.data[i].id;
                  newEntry.user_id = resp.data[i].user_id;
                  newEntry.type = resp.data[i].type;
                  newEntry.file = resp.data[i].file;
                  newEntry.original_filename = resp.data[i].original_filename;
                  newEntry.valid_until = resp.data[i].valid_until;
                  newEntry.status = resp.data[i].status;

                  if (newEntry.type == 'zzp_kvk')
                    this.displayKvkFiles.push(newEntry);
                  else
                    this.displayInsuranceFiles.push(newEntry);
                }
              }
            }
            return resolve();
          })
          .catch(() => {
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            return reject(null);
          });
      });
    },
    async saveUploads() {
      return new Promise(resolve => {
        window.scrollTo(0, 0);
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/applicant/uploads/zzpdocs/new";
        let formData = new FormData();
        for (let i = 0; i < Object.keys(this.newFiles).length; i++) {
          console.log(this.newFiles[i]);
          let nameOfFile = this.uploadedFiles[i].type + "-file";
          console.log("nameOfFile: " + nameOfFile);
          formData.append(nameOfFile, this.newFiles[i]);
        }
        formData.append("userId", this.user.id);
        console.log("formdata");
        console.log(formData);
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            resolve();
          })
          .catch(() => {
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
          });
      });
    },
    async setSuccessNotification() {
      const notification = {
        type: "success",
        message: "Jouw documenten zijn opgeslagen. We controleren ze zo snel mogelijk. Nadat je documenten zijn goedgekeurd is het mogelijk om te solliciteren!"
      };
      this.$store.dispatch("notification/replace", notification, {
        root: true
      });
    },
    onFileUpload(type) {
      console.log("onFileUpload()");
      let fullPath = document.getElementById(type + "-upload").value;
      if (fullPath == null || fullPath == "") {
        console.log("fullpath null");
        return;
      }
      let fileName = fullPath.split(/(\\|\/)/g).pop();
      console.log("onFileUpload: " + fileName);
      let newEntry = {
        id: null,
        userId: this.user.id,
        type: "zzp-" + type,
        status: "new",
        file: fileName,
        original_filename: fileName
      };
      let refName = "new_" + type + "_image";
      this.$set(this.newFiles, this.newFiles.length, this.$refs[refName].files[0]);
      this.$set(this.uploadedFiles, this.uploadedFiles.length, newEntry);
      if (type == "kvk") {
        this.$set(this.displayKvkFiles, this.displayKvkFiles.length, newEntry);
        this.hasUploadedKvkFile = true;
      }
      else {
        this.$set(this.displayInsuranceFiles, this.displayInsuranceFiles.length, newEntry);
        this.hasUploadedInsuranceFile = true;
      }

      this.hasUploadedFile = true;
    },
    async onSave() {
      this.$store.state.loading = true;
      await this.saveUploads();
      await this.setSuccessNotification();
      this.hasUploadedFile = false;
      this.$store.state.loading = false;
    },
    dateFlip(date) {
      return date.split("-").reverse().join("-");
    }
  }
};
</script>

<style scoped>
.btn-gray {
  margin: 20px 0 0;
}
.range-values div {
  position: relative;
  margin-top: -2px;
}
.range-values .float-left {
  left: -3px;
}
.range-values .float-right {
  right: -8px;
}

#collapseEducation ul li {
  margin-bottom: 5px;
}
section.block.border-bottom ul label.float-left.educ {
  height: 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-y: visible;
  overflow: hidden;
}
section.block.border-bottom ul .float-left.val.educ {
  height: 25px;
}
#collapseEducation ul li > div:not(:first-child) .val {
  position: relative;
  height: auto;
  line-height: 100%;
  padding: 3px 0;
}

section.block.border-bottom button[data-toggle="collapse"] {
  font-size: 17px;
  font-family: "Real Head Pro";
  font-weight: normal;
  border: none;
  background: none;
  padding: 0;
  color: #625a55;
  outline: none;
  width: 100%;
  position: relative;
  top: 4px;
}
section.block.border-bottom button[data-toggle="collapse"] i {
  color: #FFCD00;
  font-size: 26px;
  position: relative;
  top: -4px;
}
section.block.border-bottom button[aria-expanded] span.float-right {
  position: relative;
  display: none;
  right: -11px;
  top: 4px;
  width: 30px;
  height: 18px;
}
section.block.border-bottom button[aria-expanded="false"] span.right {
  display: block;
}
section.block.border-bottom button[aria-expanded="true"] span.down {
  display: block;
}
#app section.block.border-bottom .collapse label.educ {
  overflow:visible;
  white-space:normal;
  text-overflow:unset;
  height: inherit;
  top:0;
  line-height:normal;
}
#app section.block.border-bottom .collapse .clearfix.text-14{
  display:flex;
  height:auto;
  line-height: normal;
  min-height: 20px;
  padding: 3px 0;
}
#app section.block.border-bottom .collapse .clearfix.text-14 > *{
  float:none !important;
  flex: 50%;
}
#app section.block.border-bottom .collapse .clearfix.text-14 > *:last-child{
  height: inherit;
  position: relative;
  align-self: flex-end;
}
#app section.block.border-bottom .collapse .clearfix.text-14 > *:last-child > *{
  display:inline-block;
  line-height: normal;
}
@media screen and (max-width: 375px){
  section.block.border-bottom button {
    width: calc(100% + 5px) !important;
  }
}

</style>
